module.exports = __webpack_public_path__ + "img/lartai.fb8cfe9a.png";